import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UnscheduleSmsEdition as UnscheduleSmsEditionMutation,
    UnscheduleSmsEditionVariables as UnscheduleSmsEditionVariables,
    EditionUnscheduleInput,
} from 'nutshell-graphql-types';

import UNSCHEDULE_SMS_EDITION from '../mutations/unschedule-sms-edition.graphql';

export const useUnscheduleSmsEdition = (): {
    unscheduleSmsEdition: (arg1: EditionUnscheduleInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [unscheduleSmsEdition, {loading, error}] = useMutation<
        UnscheduleSmsEditionMutation,
        UnscheduleSmsEditionVariables
    >(UNSCHEDULE_SMS_EDITION);

    return {
        unscheduleSmsEdition: (input: EditionUnscheduleInput) =>
            unscheduleSmsEdition({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
